import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import GridContainerUI from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

import { Wrapper as WrapperCommon } from '~/src/features/center/common/styled';

export const GridContainer = styled(GridContainerUI)`
    background: radial-gradient(94.05% 87.59% at 98.66% 64.5%, rgba(255, 214, 0, .2) 0%, rgba(255, 250, 130, 0) 100%), ${COLORS.white};
    border-radius: ${BorderRadius.OuterBlockRadius};
    margin-top: 16px;

    @media (max-width: ${breakPoints.tablet}) {
        max-width: 800px;
    }

    @media (max-width: 800px) and (min-width: ${breakPoints.mobile}) {
       padding-left: 0;
       padding-right: 0;
    }

    @media (max-width: ${breakPoints.mobile}) {
        padding-left: 25px;
        padding-right: 25px;
        margin-left: 16px;
        margin-right: 16px;
        min-width: 290px;
    }
`;

export const Container = styled.div`
    width: 100%;
    margin: 0 auto;
`;

export const Wrapper = styled(WrapperCommon)`
    background-color: transparent;
    justify-content: space-between;
    padding-bottom: 60px;
    padding-left: 0;
    padding-top: 0;

    @media (max-width: ${breakPoints.tablet}) {
        justify-content: center;
        padding-left: 0;
        padding-right: 0;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        justify-content: center;
    }

    @media (max-width: 1600px) and (min-width: 1024px) {
       padding-left: 10px;
       padding-right: 10px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        width: 300px;
        justify-content: start;
        margin: 0 auto;
    }
`;

export const Text = styled.div`
    ${FONTS.H2};
    margin: 50px auto 0 auto;
    text-align: center;

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.H3};
    }
`;
